import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { CurrencyExchange } from '../models/currency-exchange ';

@Injectable({
  providedIn: 'root'
})
export class CurrencyExchangeService {
  API_URL = `${environment.apiUrl}/currency-exchange`;

  constructor(private http: HttpClient) { }

  getCurrencies(): Observable<CurrencyExchange[]> {
    return this.http.get<CurrencyExchange[]>(this.API_URL);
  }

  getActiveCurrencies(): Observable<any[]> {
    return this.http.get<any[]>(`${this.API_URL}/currencies`);
  }
 addCurrency(currency: CurrencyExchange) : Observable<CurrencyExchange>{
    return this.http.post<CurrencyExchange>(
      `${this.API_URL}/currency`,
      currency
    );
  }

  updateRow(payload: {
    oldStartDate: string;
    oldEndDate: string | null;
    startDate: string;
    endDate: string | null;
    rates: { currencyId?: number;
      currencyName?: string; exchangeRate: number | null }[];
  }): Observable<string> {
    return this.http.put(
      `${this.API_URL}/row`,
      payload,
      { responseType: 'text' }
    );
  }
 addRateExchange(payload: {
  currencyName: string;
  startDate: string;
  endDate: string | null;
  exchangeRate: number | null;
}): Observable<any> {
  return this.http.post(
    `${this.API_URL}/rate`,
    payload
  );
}
  updateCurrency(currency: CurrencyExchange): Observable<CurrencyExchange> {
    return this.http.put<CurrencyExchange>(`${this.API_URL}/${currency.id}`, currency);
  }

  deleteRow(startDate: string, endDate: string | null): Observable<void> {
    const params: any = { startDate };

    if (endDate) {
      params.endDate = endDate;
    }

    return this.http.delete<void>(
      `${this.API_URL}/row`,
      { params }
    );
  }
}